<script setup lang="ts">
const authStore = useAuthStore();
const colorMode = useColorMode();

const isDark = computed({
  get () {
    colorMode.value = LocalStorage.theme.value;
    return colorMode.value === "dark";
  },
  set () {
    colorMode.preference = colorMode.value === "dark" ? "light" : "dark";
    LocalStorage.theme.value = colorMode.preference;
  }
});

const icon = computed(() => isDark.value ?
  { name: "i-tabler-moon", color: "yellow" } : { name: "i-tabler-sun", color: "indigo" }
);
</script>

<template>

  <div class="inline-flex items-center">

    <UToggle
      v-model="isDark"
      :disabled="authStore.isUser.cursed"
      color="indigo"
      size="xs">
    </UToggle>

    <UIcon
      class="ml-1.5"
      :name="icon.name"
      :color="icon.color" />

  </div>

</template>
